module.exports = __webpack_public_path__ + "media/images/icons/yellow-star-ce4fe894bdd2549ea7697638528916fd.svg";